module.exports = __webpack_public_path__ + "img/DSWTrainingPart2.0e8353a6.jpg";